import React, { ReactElement } from 'react';
import { ToolbarProps, NavigateAction } from 'react-big-calendar';
import './CalendarToolbar.scss';
import { capitalize } from '../../utils/textUtils';
import classNames from 'classnames';

export type SummaryItem = {
  icon: string;
  label: string;
  value: string | number;
  suffix?: string;
  highlight?: boolean;
};

interface Props<TEvent extends object = any> extends Omit<ToolbarProps<TEvent>, 'onView' | 'views' | 'view'> {
  onNavigate: (action: NavigateAction) => void;
  label: string;
  summaryItems?: SummaryItem[];
  customSummaryItems?: ReactElement[];
}

export const CalendarToolbar = <TEvent extends object = any>({
  onNavigate,
  label,
  summaryItems,
  customSummaryItems,
}: Props<TEvent>) => {
  return (
    <div className='calendar-toolbar'>
      <div className='toolbar-navigation'>
        <button type='button' onClick={() => onNavigate('PREV' as NavigateAction)}>
          <i className='pi pi-chevron-left' />
        </button>
        <span className='toolbar-label'>{capitalize(label)}</span>
        <button type='button' onClick={() => onNavigate('NEXT' as NavigateAction)}>
          <i className='pi pi-chevron-right' />
        </button>
      </div>

      <div className='toolbar-content'>
        {summaryItems && summaryItems.length > 0 && (
          <div className='toolbar-summary'>
            {summaryItems.map((item, index) => (
              <div key={index} className={classNames('summary-item', { highlight: item.highlight })}>
                <i className={item.icon} />
                <span>
                  {item.label}: {item.value}
                  {item.suffix}
                </span>
              </div>
            ))}
            {customSummaryItems &&
              customSummaryItems.map((item, index) => (
                <div key={index} className='summary-item'>
                  {item}
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};
